import React from 'react';
import { useSelector } from 'react-redux';
import { Content as ContentLayout } from '../../../components/layouts/content';
import { isProspectMode } from '../../../selectors/user/user-features-selector';
import FormattedMessage from 'components/formatted-message';
import styles from './footer.module.css';

const Footer = () => {
    const prospectMode = useSelector(isProspectMode);
    const currentYear = new Date().getFullYear();

    return (
        <div className={styles.footer}>
            <ContentLayout inline>
                <div className={styles.leftContent}>
                    <FormattedMessage id="appContainer.footer.copyright" values={{ year: currentYear }} />
                    <FormattedMessage id="appContainer.footer.privacyPolicy" className={styles.inertLink} />
                    <FormattedMessage id="appContainer.footer.termsOfService" className={styles.inertLink} />
                    <a className={styles.link} href="/dmca">
                        <FormattedMessage id="appContainer.footer.dmca" />
                    </a>
                </div>
                {!prospectMode && (
                    <div className={styles.rightContent}>
                        <FormattedMessage id="appContainer.footer.allTimesInEt" />
                    </div>
                )}
            </ContentLayout>
        </div>
    );
};

export default Footer;
